import { useState } from 'react';
import { Button } from 'src/@/components/ui/button';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from 'src/@/components/ui/dialog';
import { Textarea } from 'src/@/components/ui/textarea';
import { Label } from 'src/@/components/ui/label';
  
  // ----------------------------------------------------------------------
  
  export default function ModalTratamentoIA({
    user,
    open,
    onClose,
    onSubmit,
    pesquisa,
    changePesquisa,
    dataPesquisa,
    onSelect,
    loading
  }) {

    const [respostaErrada, setRespostaErrada] = useState("");
    const [respostaCorreta, setRespostaCorreta] = useState("");
  
  
    const handleSubmit = () => {
      if (respostaErrada && respostaCorreta) {
        onSubmit({
          respostaErrada: respostaErrada,
          respostaCorreta: respostaCorreta
        });
      }
    };
  
    return (
      <Dialog open={open} onOpenChange={onClose}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Tratamento de IA - Feedback</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-6 py-4">
            <div className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="resposta-errada" className="text-sm font-medium">
                  O que o agente respondeu errado?
                </Label>
                <Textarea
                  id="resposta-errada"
                  placeholder="Descreva a resposta incorreta do agente..."
                  value={respostaErrada}
                  onChange={(e) => setRespostaErrada(e.target.value)}
                  className="min-h-[80px]"
                />
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="resposta-correta" className="text-sm font-medium">
                  O que ele deveria responder?
                </Label>
                <Textarea
                  id="resposta-correta"
                  placeholder="Descreva a resposta correta que deveria ter sido dada..."
                  value={respostaCorreta}
                  onChange={(e) => setRespostaCorreta(e.target.value)}
                  className="min-h-[80px]"
                />
              </div>
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            {respostaErrada && respostaCorreta && (
              <ButtonLoading loading={loading} onClick={handleSubmit}>
                Enviar Feedback para IA
              </ButtonLoading>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
